import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoBem: CultureInfo = {
  name: 'bem',
  displayName: 'Ichibemba',
  iso3LanguageCode: 'bem',
  iso2LanguageCode: 'bem',
  ietfLanguageTag: 'bem',
  parent: null
};
